import React from 'react';
import { motion } from 'framer-motion';
import { CrownIcon, XIcon } from 'lucide-react';
import { ProductName } from './ProductName';
import { FlowLine } from './FlowLine';
import { Ornament } from './Ornament';
const notThis = ['This is not a random collection of dance combinations.', 'This is not another text-heavy dance manual that leaves you wondering how to turn theory into a real class.', 'And it is not a folder full of disconnected resources you still need to organize yourself.'];
const usageSteps = ['Open the system.', 'Choose the objective.', 'Find the progression.', 'Teach.'];
export function SolutionReveal() {
  return <section className="bg-ink px-4 py-20 text-cream sm:py-28" data-id="element-267" data-mp="17zydbx7g8hc0">
      <div className="mx-auto max-w-4xl text-center" data-id="element-268" data-mp="13zeln95na5x9">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-269" data-mp="2jh7uue70ozao">
          <span className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full border border-gold/60 text-gold" data-id="element-270" data-mp="2bw8ldchctz33">
            <CrownIcon size={24} strokeWidth={1.5} aria-hidden="true" data-id="element-271" data-mp="2gt8q9k2gwvsm" />
          </span>
          <p className="mt-5 text-sm font-semibold uppercase tracking-[0.18em] text-cream/70" data-id="element-272" data-mp="2kxovrk86617b">
            The complete <span className="text-champagne" data-id="element-273" data-mp="2puyhaosftspv">6-in-1</span> visual
            teaching system for Salsa & Bachata instructors
          </p>
          <h2 className="mt-4 text-3xl font-semibold leading-tight text-gold sm:text-5xl" data-id="element-274" data-mp="1t3ehpep6lte6">
            <ProductName script accentClassName="text-champagne" data-id="element-275" data-mp="1x4gfrs7d3zek" />
          </h2>
          <Ornament className="mt-5" data-id="element-276" data-mp="224l0jufazgal" />
          <h3 className="mx-auto mt-5 max-w-2xl text-2xl font-medium italic text-cream" data-id="element-277" data-mp="26wcgzc4qw5n0">
            Solve an entire year of Salsa & Bachata classes in just 5 MINUTES
          </h3>
          <p className="mx-auto mt-4 max-w-3xl text-sm font-medium uppercase leading-7 tracking-[0.08em] text-cream/70" data-id="element-278" data-mp="19fdywmkjyal4">
            6 Complete Instructor Volumes · 150 Ready-to-Teach Classes · 100%
            Visual Core System · 5 Professional Bonus Guides
          </p>
        </motion.div>

        <div className="mt-12 grid gap-5 text-left md:grid-cols-2" data-id="element-279" data-mp="2cqbcwthr2qkk">
          <div className="space-y-4 rounded-xl border border-white/10 bg-white/[0.03] p-6" data-id="element-280" data-mp="2qj1194kr47ku">
            {notThis.map(item => <div key={item} className="flex gap-3 text-sm leading-6 text-cream/75" data-id="element-281" data-mp="2mkbgus1apprp">
                <XIcon size={18} className="mt-0.5 shrink-0 text-gold" aria-hidden="true" data-id="element-282" data-mp="1tu1r1k0lwvq0" />
                {item}
              </div>)}
          </div>
          <div className="rounded-xl border border-gold/40 bg-ink-soft p-6" data-id="element-283" data-mp="22seudgmhgtcf">
            <p className="text-base font-medium leading-7 text-cream" data-id="element-284" data-mp="3j76nxwvd86nb">
              Salsa & Bachata Instructor Ready is a complete 6-in-1 visual
              teaching system created to help Salsa and Bachata instructors
              plan less, teach with greater structure and guide students
              progressively from beginner to advanced.
            </p>
            <p className="mt-3 text-sm leading-6 text-cream/70" data-id="element-285" data-mp="3cs7resouxtp2">
              The six-volume core system is designed around visual
              explanations, movement sequences, partner positioning, floor
              pathways, technical breakdowns, correct-vs-incorrect comparisons,
              progressions and ready-to-teach class structures.
            </p>
            <FlowLine tone="dark" className="mt-5" label="So instead of reading endless theory, you can:" steps={['See it', 'Understand it', 'Teach it']} data-id="element-286" data-mp="e9j3aveyt9x9" />
            <ol className="mt-5 space-y-2.5" data-id="element-287" data-mp="sa3kxo958zp6">
              {usageSteps.map((step, index) => <li key={step} className="flex items-start gap-3 text-sm leading-6 text-cream" data-id="element-288" data-mp="x0tmsrid2kf4" data-mpi={index}>
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-gold/60 bg-wine text-[11px] font-bold text-cream" data-id="element-289" data-mp="34l6b0oahkkds">
                    {index + 1}
                  </span>
                  {step}
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}